<div class="sovos-callback" *ngIf="isProcessing && !displayConsentModal">
  <p>Processing SOVOS callback, please wait...</p>
</div>

<div
  *ngIf="displayConsentModal"
  class="modal fade show consent-modal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  aria-labelledby="sovosConsentModalLabel">
  <div class="modal-dialog modal-dialog-centered" role="document" style="margin-top: 0px !important;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="sovosConsentModalLabel">Consent Box</h5>
      </div>
      <div class="modal-body">
        <div class="form-check form-constent-sign-in">
          <input type="checkbox" class="form-check-input" id="sovosConsentGiven" [(ngModel)]="isChecked" />
          <label class="form-check-label form-constent-sign-in-label" for="sovosConsentGiven">
            In compliance with the Information Technology Act 2000 and related
            rules, we seek your consent to collect and use
            your personal data (e.g. email ID, mobile number) for authentication,
            notifications, and service facilitation on
            our platform. By providing your personal data, you agree to its
            collection, use, processing, and storage as per our
            <a
              style="color: #0574d5 !important;"
              class="clrWhite text-decoration-underline"
              href="https://sovos.com/software-and-services-terms/"
              target="_blank"
              rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>
            and
            <a
              style="color: #0574d5 !important;"
              class="clrWhite text-decoration-underline"
              href="https://sovos.com/software-and-services-terms/data-privacy/"
              target="_blank"
              rel="noopener noreferrer">
              Privacy Policy
            </a>.
            Your data will not be disclosed
            without your explicit consent unless required
            by law.
          </label>
        </div>
        <div *ngIf="isSubmittedConsent && !isChecked" style="margin-left: 18px;">
          <span class="text-danger">Consent Required</span>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          [ngClass]="{ 'disabled-btn': !isChecked }"
          (click)="submitConsent()"
          class="btn btn-primary"
          [disabled]="!isChecked || isProcessing">
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="displayConsentModal" class="modal-backdrop fade show"></div>
